import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminHyperlinkComponent } from './admin-hyperlink.component';
import { SharedModule } from '@shared/shared.module';
import {
    AdminHyperlinkCreateComponent,
    AdminHyperlinkEditComponent,
    AdminHyperlinkInfoComponent,
    AdminHyperlinkItemComponent
} from '@app/main/admin/modules/admin-hyperlink/components';

@NgModule({
    declarations: [
        AdminHyperlinkComponent,
        AdminHyperlinkItemComponent,
        AdminHyperlinkInfoComponent,
        AdminHyperlinkEditComponent,
        AdminHyperlinkCreateComponent
    ],
    exports: [AdminHyperlinkComponent],
    imports: [CommonModule, SharedModule]
})
export class AdminHyperlinkModule {}
